/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Retention — curves, churn, weekly cohort grid, segments. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  function segScope(sg){var h=document.querySelector('[data-segtitle]');if(!h||!sg||!sg.name)return;var s=h.querySelector('.gs-seg-scope');if(!s){s=document.createElement('span');s.className='gs-seg-scope';s.style.cssText='color:#6B7280;font-weight:500;font-size:.6em;margin-left:7px;letter-spacing:normal;vertical-align:middle';h.appendChild(s);}s.textContent='\u00b7 '+sg.name;}
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["retention"] = "1.0.2"; } catch (e) {}
  var root, SEGMENTS=[], CUR=0;
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function qa(s){ return root?Array.prototype.slice.call(root.querySelectorAll(s)):[]; }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function pc(v){ return v===null||v===undefined?"—":(v+"%"); }
  function ready(fn){ var d=false; function go(){ if(d)return; d=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }
  function api(path,opts){ return GS.api(path+(path.indexOf("?")<0?"?":"&")+"site="+encodeURIComponent(GS.site),opts); }

  function loadSegments(){ api("/plugin/retention/list").then(function(r){ SEGMENTS=(r.ok&&r.data&&r.data.segments)||[]; var sel=q("seg-sel");
    sel.innerHTML='<option value="0">'+TT('rete.js.all_visitors')+'</option>'+SEGMENTS.map(function(s){return '<option value="'+s.id+'">'+esc(s.name)+'</option>';}).join(""); sel.value=String(CUR); }); }

  function load(){
    api("/plugin/retention/stats?id="+CUR+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data)return; var d=r.data;
      q("stitch-note").hidden = !!d.stitch;
      q("k-d1").textContent=pc(d.day1); q("k-d7").textContent=pc(d.day7); q("k-d30").textContent=pc(d.day30); q("k-churn").textContent=pc(d.churn_rate);
      renderCurve(d.curve||[]); renderGrid(d.grid||[]);
      segScope(d.scoped_segment);
    });
  }
  function renderCurve(curve){
    var host=q("curve");
    var pts=curve.filter(function(c){return c.eligible>0;});
    if(!pts.length){ host.innerHTML='<div class="empty">'+TR('retent.g.not_enough_data_for_a_retention_curv')+'</div>'; return; }
    var W=620,H=220,padL=36,padB=26,padT=12,padR=12;
    var maxX=Math.max.apply(null,pts.map(function(p){return p.offset;}))||1;
    function x(o){ return padL+(o/maxX)*(W-padL-padR); }
    function y(v){ return padT+(1-v/100)*(H-padT-padB); }
    function line(key,cls,dash){ var seg=pts.filter(function(p){return p[key]!==null;});
      if(!seg.length)return ""; var d=seg.map(function(p,i){return (i?"L":"M")+x(p.offset).toFixed(1)+" "+y(p[key]).toFixed(1);}).join(" ");
      var dots=seg.map(function(p){return '<circle cx="'+x(p.offset).toFixed(1)+'" cy="'+y(p[key]).toFixed(1)+'" r="3" class="'+cls+'"/>';}).join("");
      return '<path d="'+d+'" fill="none" class="'+cls+'" '+(dash?'stroke-dasharray="5 4"':'')+'/>'+dots; }
    var grid=[0,25,50,75,100].map(function(g){ return '<line x1="'+padL+'" y1="'+y(g).toFixed(1)+'" x2="'+(W-padR)+'" y2="'+y(g).toFixed(1)+'" class="gl"/><text x="4" y="'+(y(g)+3).toFixed(1)+'" class="ax">'+g+'</text>'; }).join("");
    var xlab=pts.map(function(p){ return '<text x="'+x(p.offset).toFixed(1)+'" y="'+(H-8)+'" class="ax" text-anchor="middle">d'+p.offset+'</text>'; }).join("");
    host.innerHTML='<svg viewBox="0 0 '+W+' '+H+'" style="width:100%;height:auto">'+grid+xlab+line("rolling_pct","ln-r",true)+line("classic_pct","ln-c",false)+'</svg>';
  }
  function renderGrid(grid){
    var host=q("grid");
    if(!grid.length){ host.innerHTML='<div class="empty">'+TR('retent.f2.no_cohorts_in_this_range')+'</div>'; return; }
    var head='<div class="ret-gcell gh">'+TR('retent.g.cohort')+'</div><div class="ret-gcell gh">'+TR('retent.g.size')+'</div>';
    for(var w=0;w<=5;w++) head+='<div class="ret-gcell gh">Wk '+w+'</div>';
    var rows=grid.map(function(r){
      var c='<div class="ret-gcell gl2">'+esc(r.label)+'</div><div class="ret-gcell gsz">'+r.size+'</div>';
      c+=r.cells.map(function(x){ if(x.pct===null)return '<div class="ret-gcell gempty">—</div>';
        var a=(x.pct/100); return '<div class="ret-gcell" style="background:rgba(31,164,99,'+(0.12+a*0.8).toFixed(2)+');color:'+(a>0.55?'#fff':'#0f2a1c')+'">'+x.pct+'%</div>'; }).join("");
      return c;
    }).join("");
    host.innerHTML='<div class="ret-grid">'+head+rows+'</div>';
  }

  // ---- segment builder ----
  function addRule(rule){
    var tpl=document.getElementById("ret-rule-tpl"); var node=tpl.content.firstElementChild.cloneNode(true);
    if(rule){ node.querySelector('[data-r="type"]').value=rule.rule_type; node.querySelector('[data-r="value"]').value=rule.rule_value; }
    node.querySelector('[data-r="del"]').onclick=function(){ node.remove(); };
    q("ret-rules").appendChild(node);
  }
  function openBuilder(id){
    if (window.GSLink) window.GSLink.write({ id: id });   // the open view becomes linkable
    var m=q("ret-modal"); q("ret-rules").innerHTML="";
    var run=function(seg){
      m.querySelector('[data-f="id"]').value=seg?seg.id:"";
      m.querySelector('[data-f="name"]').value=seg?seg.name:"";
      m.querySelector('[data-f="match_type"]').value=seg?seg.match_type:"all";
      m.querySelector('[data-f="paused"]').checked=seg&&seg.status==="paused";
      (seg&&seg.rules||[]).forEach(addRule); if(!seg||!(seg.rules||[]).length)addRule(null);
      q("ret-mtitle").textContent=id?"Edit segment":TR('retent.g.new_segment'); m.hidden=false;
    };
    if(id)api("/plugin/retention/get?id="+id).then(function(r){ run(r.ok&&r.data&&r.data.segment?r.data.segment:null); }); else run(null);
  }
  function saveSeg(){
    var m=q("ret-modal");
    var rules=Array.prototype.slice.call(q("ret-rules").querySelectorAll("[data-rule]")).map(function(n){
      return {rule_type:n.querySelector('[data-r="type"]').value, rule_value:n.querySelector('[data-r="value"]').value}; }).filter(function(r){return r.rule_value!=="";});
    var body={action:"save",id:+m.querySelector('[data-f="id"]').value||0,name:m.querySelector('[data-f="name"]').value,
      match_type:m.querySelector('[data-f="match_type"]').value,status:m.querySelector('[data-f="paused"]').checked?"paused":"active",rules:rules};
    api("/plugin/retention/create",{method:"POST",body:JSON.stringify(body)}).then(function(r){ if(r.ok){ m.hidden=true; loadSegments(); } });
  }

  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={30:T("an.last30"),60:T("an.last60"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_ret_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(60); })();
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_ret_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; load(); }); });
    var _ap=menu.querySelector('[data-rp="apply"]');if(_ap)_ap.addEventListener("click",function(){var ff=(menu.querySelector('[data-rp="from"]')||{}).value,tt=(menu.querySelector('[data-rp="to"]')||{}).value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}RANGE={from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null};if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_retention_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";load();});
    btn.addEventListener("click",function(){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf&&RANGE.from)cf.value=RANGE.from;if(ct&&RANGE.to)ct.value=RANGE.to;});
  }
  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    q("seg-sel").onchange=function(){ CUR=+q("seg-sel").value; load(); };
    q("new-seg").onclick=function(){ openBuilder(0); };
    q("ret-addrule").onclick=function(){ addRule(null); };
    q("ret-save").onclick=saveSeg;
    ["ret-close","ret-cancel"].forEach(function(k){ q(k).onclick=function(){ q("ret-modal").hidden=true; }; });
    initRange(); loadSegments(); load();
  }
  /* Deep link: /retention?id=<v> opens that view directly, so it can be linked from an email,
     a dashboard widget or another report. The spelling lives in GSLink so no two pages can
     disagree about it. The inline fallback covers the window before gs-deeplink.js is deployed —
     it must ASSIGN, not return: an early return exits gsDeep() and the opener never fires.
     Anything malformed is ignored and the normal list loads. */
  function gsDeep() {
    var v = null;
    if (window.GSLink) {
      v = window.GSLink.read({ id: "int" }).id;
    } else {
      try {
        var p = new URLSearchParams(location.search);
        var _n = parseInt(String(p.get("id") || "").replace(/[^0-9-]/g, ""), 10);
        v = isNaN(_n) ? null : _n;
      } catch (e) { v = null; }
    }
    if (v !== null && v !== "") openBuilder(v);
  }
  ready(function () { init(); gsDeep(); });
})();
